import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LayoutContext } from "../../hooks/layout-context";
import CarsListing from "../../components/cars-listing";

export default function TuningList() {
  const { t } = useTranslation();
  const { layout, setLayout } = useContext(LayoutContext);

  React.useEffect(() => {
    layout.sideMenu = "tuning";
    layout.breadcrumbs = [{ path: null, label: "Tuningowane" }];
    setLayout({ ...layout });
  }, []);

  return <CarsListing asTuning={true} />;
}
